import { useEffect } from 'react';
import ThLoading from '@components/elements/ThLoading';

const SERVER_URL = import.meta.env.VITE_SERVER_BASE_URL;

function CompanyInactive() {
  useEffect(() => {
    window.location.href = `${SERVER_URL}/companyDashboard/home`;
  }, []);

  return <ThLoading />;
}

export default CompanyInactive;
